import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export interface FAQItem {
  q: string;
  a: string;
}

interface LandingFAQProps {
  title?: string;
  subtitle?: string;
  faqs: FAQItem[];
}

const LandingFAQ = ({
  title = "Frequently Asked Questions",
  subtitle,
  faqs,
}: LandingFAQProps) => {
  return (
    <section className="container mx-auto px-6 py-20" aria-labelledby="faq-heading">
      <div className="text-center mb-12">
        <h2 id="faq-heading" className="text-3xl md:text-4xl font-bold mb-3">
          {title}
        </h2>
        {subtitle && (
          <p className="text-muted-foreground max-w-lg mx-auto">{subtitle}</p>
        )}
      </div>

      <Accordion type="single" collapsible className="max-w-2xl mx-auto">
        {faqs.map((f, i) => (
          <AccordionItem key={i} value={`faq-${i}`}>
            <AccordionTrigger className="text-left text-foreground">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-muted-foreground leading-relaxed">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
};

export default LandingFAQ;
